import { observable, action, runInAction } from 'mobx';
import { Modal } from 'antd';
import axios from 'axios';
const { confirm } = Modal;

export class BillingStore {
    @observable countries = [];
    @observable subscriptions = [];
    @observable invoices = [];
    @observable currentInvoice = null;
    @observable legacySubscriptions = [];
    @observable packages = [];

    @observable paypalSubs = [];
    @observable cbSubs = [];

    constructor({ rootStore }) {
        this.rootStore = rootStore;
    }

    @action async getPackages(bot_type = 'apex') {
        const response = await axios.get(`${this.rootStore.env.billingApi}packages/${bot_type}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });

        runInAction(() => {
            this.packages = response.data;
        });
    }

    @action async getBillingCountries() {
        const response = await axios.get(`${this.rootStore.env.billingApi}countries`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });

        runInAction(() => {
            this.countries = response.data;
        });
    }

    @action async getSubscriptions() {
        const { data } = await axios.get(`${this.rootStore.env.billingApi}subscriptions`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
        runInAction(() => {
            this.subscriptions = data;
        });
    }

    @action async getInvoices() {
        const { data } = await axios.get(`${this.rootStore.env.billingApi}invoices`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
        runInAction(() => {
            this.invoices = data;
        });
    }

    @action async getInvoice(id) {
        const { data } = await axios.get(`${this.rootStore.env.billingApi}invoice/${id}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
        runInAction(() => {
            this.currentInvoice = data;
        });
    }

    @action async getLegacySubscriptions() {
        const { data } = await axios.get(
            `${this.rootStore.env.billingApi}subscriptions/migration_required`,
            {
                headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
            }
        );
        runInAction(() => {
            this.legacySubscriptions = data;
        });
    }

    @action async cancelSubscription(id) {
        await axios.get(`${this.rootStore.env.billingApi}subscription/${id}/cancel`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    @action async createSubscription(
        packageId,
        term,
        paymentMethod,
        billingDetails,
        existingSubscription
    ) {
        const { data } = await axios.post(
            `${this.rootStore.env.billingApi}subscription/create`,
            {
                package_id: packageId,
                term,
                payment_method: paymentMethod,
                existing_subscription: existingSubscription,
                billing_details: billingDetails
            },
            {
                headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` },
                timeout: 10000
            }
        );

        if (data.redirect_url) {
            return (window.location.href = data.redirect_url);
        }
    }

    async extendSubscription(subscriptionId) {
        const { data } = await axios.post(
            `${this.rootStore.env.billingApi}subscription/${subscriptionId}/extend`,
            {},
            {
                headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
            }
        );

        if (data.redirect_url) {
            return (window.location.href = data.redirect_url);
        }
    }

    @action async assignBotToSubscription(subscription, botConfig) {
        confirm({
            title: `Do you want to assign ${botConfig.name} to this subscription?`,
            content: 'If a bot is currently attached it will be shut down',
            onOk: async () => {
                const { data } = await axios.post(
                    `${this.rootStore.env.billingApi}subscription/${subscription._id}/assign`,
                    { bot_config: botConfig._id || botConfig.id },
                    {
                        headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
                    }
                );
            },
            onCancel() {
                //noop
            }
        });
    }

    /**
     * LEGACY
     */

    async createUserAgreement(poolId) {
        const currentUser = this.rootStore.fbAuth.currentUser;
        if (!currentUser) throw new Error('not permitted');

        return await axios.get(
            `${this.rootStore.env.functionsPath}/paypalCreateUserAgreement?pool_id=${poolId}`
        );
    }

    async executeUserAgreement(paymentToken, poolId) {
        const currentUser = this.rootStore.fbAuth.currentUser;
        if (!currentUser) throw new Error('not permitted');

        return await axios.post(`${this.rootStore.env.functionsPath}/paypalExecuteUserAgreement`, {
            uid: currentUser.uid,
            pool_id: poolId,
            payment_token: paymentToken
        });
    }

    @action async getSubscriptionStatusForBot(poolId) {
        const currentUser = this.rootStore.fbAuth.currentUser;
        if (!currentUser) throw new Error('not permitted');

        this.paypalSubsWatcher = await this.rootStore.db
            .collection('subscriptions')
            .where('pool_id', '==', poolId)
            .onSnapshot(subscriptions => {
                let docs = [];
                subscriptions.forEach(snap => {
                    docs.push({ ...snap.data() });
                });
                runInAction(() => {
                    this.paypalSubs = docs;
                });
            });

        this.cbSubsWatcher = await this.rootStore.db
            .collection('coinbase_charges')
            .where('pool_id', '==', poolId)
            .onSnapshot(subscriptions => {
                let docs = [];
                subscriptions.forEach(snap => {
                    docs.push({ ...snap.data() });
                });
                runInAction(() => {
                    this.cbSubs = docs;
                });
            });
    }

    @action close() {
        this.paypalSubsWatcher();
        this.cbSubsWatcher();
    }
}



// WEBPACK FOOTER //
// ./src/stores/BillingStore.js